// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './bookmark-type.model';
export * from './bookmark.model';
// @endindex